<section *ngIf="invoice" class="payment-page">
  <mat-card class="payment-card">
    <mat-card-content>
      <header class="payment-header">
        <button
          mat-icon-button
          type="button"
          class="back-button"
          (click)="returnToDashboard()"
          matTooltip="Voltar"
          aria-label="Voltar"
        >
          <mat-icon>arrow_back</mat-icon>
        </button>

        <div class="header-copy">
          <h1>Detalhe da cobrança</h1>
        </div>
      </header>

      <section class="summary-card">
        <div class="summary-main">
          <span class="eyebrow">Cobrança</span>
          <strong>{{ invoice.DESCRICAO_FATURA }}</strong>
          <div class="summary-meta">
            <span>Box: {{ boxLabel }}</span>
            <span>Contrato: {{ invoiceContractLabel }}</span>
            <span>Unidade: {{ invoiceUnitLabel }} ({{invoice.LOJA_LOGRADOURO}}, {{invoice.LOJA_NUMERO}}, {{invoice.LOJA_BAIRRO}}. {{invoice.LOJA_CIDADE}}-{{invoice.LOJA_UF}})</span>
          </div>
        </div>

        <div class="summary-status">
          <mat-chip class="status-chip" [ngClass]="statusClass()">
            {{ statusLabel() }}
          </mat-chip>
          <span class="status-note" [ngClass]="statusHintClass()">{{ statusHint() }}</span>
        </div>
      </section>

      <section class="section-card items-card">
        <div class="section-header">
          <h2>Itens da cobrança</h2>
        </div>

        <div class="items-list">
          @for (item of invoice.LANCAMENTOS; track item.CODIGO_LANCAMENTO) {
            <div class="item-row">
              <div class="item-copy">
                <strong>{{ item.DESCRICAO_LANCAMENTO }}</strong>
                <span>Vencimento em {{ formatDate(item.DATA_VENCIMENTO) }}</span>
              </div>

              <div class="item-amount" [class.discount-amount]="isDiscountItem(item)">
                {{ itemAmountLabel(item) }}
              </div>
            </div>
          }
        </div>
      </section>

      <section class="section-card financial-card">
        <div class="section-header">
          <h2>Resumo financeiro</h2>
        </div>

        <div class="financial-list">
          <div class="financial-row">
            <span>Vencimento da fatura</span>
            <strong>{{ formatDate(invoice.DATA_VENCIMENTO) }}</strong>
          </div>

          <div class="financial-row">
            <span>Subtotal</span>
            <strong>{{ formatCurrency(invoice.VALOR_LANCAMENTO) }}</strong>
          </div>

          @if (invoice.ACRESCIMO > 0 && !invoice.DATA_PAGAMENTO) {
            <button type="button" class="financial-row interactive-row" (click)="disclaimerAcrescimos()">
              <span>Acréscimos</span>
              <strong class="late-fee">{{ formatCurrency(invoice.ACRESCIMO) }}</strong>
            </button>
          }

          @if (invoice.DESCONTO > 0 && !invoice.DATA_PAGAMENTO) {
            <div class="financial-row">
              <span>Desconto</span>
              <strong class="discount-amount">-{{ formatCurrency(invoice.DESCONTO) }}</strong>
            </div>
          }

          @if (invoice.DATA_PAGAMENTO == null){
            <div class="total-panel">
              <span>Total a pagar:</span>
              <br>
              <strong>{{ formatCurrency(invoice.VALOR_TOTAL) }}</strong>
            </div>
          } @else {
            <div class="total-panel-pago total-panel">
              <span>Total pago</span>
              <br>
              <strong>{{ formatCurrency(invoice.VALOR_PAGO) }}</strong>
            </div>
          }

          @if (invoice.DATA_PAGAMENTO) {
            <div class="financial-row">
              <span>Pago em</span>
              <strong class="paid-amount">{{ formatDate(invoice.DATA_PAGAMENTO) }}</strong>
            </div>
          }
        </div>
      </section>

      @if (invoice.CODIGO_NFSE) {
        <section class="section-card compact-card">
          <div class="financial-row">
            <span>Nota fiscal de serviço eletrônica</span>
            <button mat-stroked-button type="button" (click)="showNfse()">Imprimir</button>
          </div>
        </section>
      }

      <div class="payment-actions">
        @if (invoice.DATA_PAGAMENTO == null){
          <button
            class="pay-button"
            mat-raised-button
            color="primary"
            type="button"
            [matMenuTriggerFor]="menuBtnPagar"
            [disabled]="invoice.DATA_PAGAMENTO"
          >
            <mat-icon>payment</mat-icon>
            Pagar cobrança
          </button>

          <mat-menu #menuBtnPagar="matMenu">
            @if (invoice.ACEITAR_CARTAO) {
              <button mat-menu-item (click)="openCreditCardModal()">
                <mat-icon>credit_card</mat-icon>
                Cartão de crédito
              </button>
            }
            @if (invoice.ACEITAR_PIX) {
              <button mat-menu-item (click)="openPixModal()">
                <mat-icon>qr_code</mat-icon>
                Pix
              </button>
            }
            @if (invoice.ACEITAR_BOLETO) {
              <button mat-menu-item (click)="openBoletoModal()">
                <mat-icon>receipt</mat-icon>
                {{ invoice.CODIGO_BOLETO ? 'Boleto' : 'Gerar boleto' }}
              </button>
            }
          </mat-menu>
        }
      </div>
    </mat-card-content>
  </mat-card>
</section>
